import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class MediaAssetSubtitlesRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    if (item.enabled) return true;
    return super.canViewItem(item);
  }
}